import { render, staticRenderFns } from "./SetVennDiagram.vue?vue&type=template&id=0504c9f7&scoped=true"
import script from "./SetVennDiagram.vue?vue&type=script&lang=js"
export * from "./SetVennDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504c9f7",
  null
  
)

export default component.exports